import { lazyLoad } from "../../../../utils/loadable.js";

export const MyAccount = lazyLoad(
    () => import("./index.js"),
    (module) => module.MyAccount,
);
